export const voiceCalls = {
  "head": {
    "title": "Calls",
    "subtitle": "The calls your phone reception has answered."
  },
  "stats": {
    "all": "call | calls",
    "spoken": "answered | answered",
    "inTotal": "in total"
  },
  "toolbar": {
    "searchLabel": "Search",
    "searchPlaceholder": "Caller's phone number…",
    "clear": "Clear search",
    "showLabel": "Show",
    "showAll": "All calls",
    "showSpoken": "Only answered",
    "showRecorded": "Only recorded"
  },
  "notice": {
    "noRecording": "Calls are not being recorded.",
    "noRecordingHow": "Turn on “Record calls” in your phone reception settings and from then on you will be able to listen to them and transcribe them here."
  },
  "empty": {
    "title": "Nobody has called you yet",
    "text": "When someone calls your reception number, the call will show up here with who called, how long it lasted and what they wanted.",
    "filteredTitle": "No calls match that filter",
    "filteredText": "Try clearing the search or the filters above."
  },
  "item": {
    "notSpoken": "Never spoke",
    "unknownCaller": "Withheld number",
    "linkSent": "Booking link sent",
    "play": "Play the recording",
    "pause": "Pause",
    "showTranscript": "Show transcript",
    "hideTranscript": "Hide transcript",
    "transcribe": "Transcribe and summarise",
    "transcribing": "Transcribing…",
    "noRecordingShort": "This call was not recorded",
    "viewReservation": "View booking",
    "noSummary": "This call has no summary.",
    "copy": "Copy the number",
    "copied": "Copied"
  },
  "errors": {
    "load": "The calls could not be loaded.",
    "play": "The recording could not be played.",
    "transcribe": "The transcript could not be requested."
  },
  "table": {
    "call": "Call",
    "reservation": "Booking",
    "listing": "Property",
    "summary": "Summary",
    "duration": "Length",
    "date": "Date"
  }
};
